import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.jsx';
import './index.css';

// ------------------------------------------------------------------
// Hashless-URL normalization (must run BEFORE the router boots).
//
// The SPA uses HashRouter, so real routes live after "#" — but users
// arrive on hashless URLs (/engineer/premiere, /portal/premiere,
// /admin — from bookmarks, emails, QR codes, docs). Caddy's SPA fallback
// serves index.html for those, the app boots with an EMPTY hash, the
// router sees "/" and the catch-all throws the user to #/admin/login
// (seen in production: /engineer/premiere → /engineer/premiere#/admin/login).
//
// Two cases, both fixed before React mounts:
//   1. No hash + non-root pathname → move the pathname into the hash.
//   2. Non-root pathname + hash DISAGREEING at the first segment → the
//      pathname wins. With HashRouter the pathname never changes after
//      first load, so this state only arises when a past visit's broken
//      catch-all bolted #/admin/login onto an engineer/portal URL — the
//      pathname is the entry intent, the hash is the bug's residue
//      (and it lives in poisoned bookmarks until rewritten here).
// /pb/* and /api/* never reach the SPA (Caddy proxies them); asset
// paths carry extensions and are excluded.
// ------------------------------------------------------------------
(() => {
  const { pathname, hash, search } = window.location;
  const clean = pathname.replace(/\/+$/, '');
  const looksLikeFile = /\.[a-z0-9]+$/i.test(clean);
  if (!clean || clean === '/' || looksLikeFile) return;

  if (!hash) {
    window.history.replaceState(null, '', `/#${clean}${search}`);
    return;
  }

  const pathTop = clean.split('/')[1];
  const hashTop = (hash.slice(1).split('?')[0].split('/')[1]) || '';
  if (hashTop && pathTop && hashTop !== pathTop) {
    window.history.replaceState(null, '', `/#${clean}${search}`);
  }
})();

createRoot(document.getElementById('root')).render(
<StrictMode>
    <App />
</StrictMode>
);
